// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'play-with-oreo',
  heroImg: 'hero.jpg',
  heroTheme: 'dark',
  heroHeadingOne: 'PLAY WITH OREO',
  heroHeadingTwo: 'SOCIAL MEDIA HUB / INTERACTIVE ADS',
  details: [
    {
      title: 'Client',
      items: ['360i'],
    },
    {
      title: 'Brand',
      items: ['Oreo'],
    },
    {
      title: 'Platform',
      items: ['Web'],
    },
  ],
  heading: 'CREATING AN INTERNATIONAL SOCIAL MEDIA PLATFORM TO SUPPORT A GLOBAL MARKETING CAMPAIGN',
  challengeImg: 'challenge.jpg',
  challenge: [
    'To create a next-generation social hub utilising innovative methods to increase dwell time and engagement. The site needed to form a global platform for Oreo with interface and moderation tools in multiple languages.',
  ],
  solutionImg: 'solution.jpg',
  solution: [
    'Working with leading US digital agency 360i, we designed and developed a responsive social wall showcasing premium brand content and user-generated responses, combined with a playful navigation incorporating the nine ‘Play With Oreo’ themes.',
    'The experience also included an Oreo avatar creator, which allowed users to create personalised ‘Oreo Heads’ from over 250 different elements and submit them for approval for inclusion on the wall.',
    'We developed rich media engagement ads, featuring an Oreo-themed game, which accompanied the campaign, and were used around the world to drive over 1.75m users to the site.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: '',
      content: ['OREO HEAD CREATOR UGC TOOL INCREASED DWELL TIME BY 9%.'],
    },
    {
      img: 'callout_2.jpg',
      title: '',
      content: ['RICH MEDIA ENGAGEMENT ADS DISTRIBUTED ACROSS ALL GLOBAL MARKETS.'],
    },
    {
      img: 'callout_3.jpg',
      title: '',
      content: ['PLAYFUL NAVIGATION AROUND HERO AREA INCREASED ENGAGEMENT WITH BRAND CONTENT OVER STANDARD SOCIAL WALL STRUCTURE.'],
    },
  ],
  nextCaseStudy: 'getty-events',
};

export default casestudyData;
